"use client";

import { ErrorCard } from "@/components/ui/ErrorCard";

type ErrorProps = { error: Error & { digest?: string }; reset: () => void };

export default function Error(props: ErrorProps) {
  return (
    <ErrorCard
      {...props}
      heading="Anfragen konnten nicht geladen werden"
      message="Beim Laden Ihrer Anfragen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."
      logPrefix="anfragen"
    />
  );
}
